import { render } from "./link.vue?vue&type=template&id=2e795819&scoped=true"
const script = {}

import "./link.vue?vue&type=style&index=0&id=2e795819&scoped=true&lang=css"

import exportComponent from "D:\\vue.js-tut\\czn\\online\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e795819"]])

export default __exports__